module.exports = __webpack_public_path__ + "static/media/tonko_JJ.c1d1343c.JPG";